module.exports = __webpack_public_path__ + "static/media/Towing Assistance.db38886e.png";